<style scoped>
label {
  font-weight: 600;
  font-size: 13px;
  color: #7a7a7a;
  text-transform: capitalize;
  margin-bottom: 2px;
}
p {
  color: #535353;
  font-size: 13px;
  font-weight: 600;
  margin-bottom: 2px;
}
.text-view {
  border-bottom: 1px dashed #dddddd;
  padding: 0;
  margin: 8px 48px;
}
</style>
<template>
  <b-row class="text-view">
    <b-col
      cols="2"
      class="mr-0 pl-0 d-flex justify-content-start align-item-start"
    >
      <label>{{ label }}</label></b-col
    >
    <b-col class="ml-0 pr-0 mb-2 d-flex justify-content-start align-item-start">
      <div
        v-for="(item, index) in data"
        :key="index"
        style="margin-top: -4px; padding-right: 2em"
      >
        <label style="font-weight: 800; color: #01579b">{{ item.name }}:</label>
        <p>{{ item.definition }}</p>
      </div>
      <p v-if="data.length == 0">-</p>
    </b-col>
  </b-row>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
    },
    data: {
      type: Array,
    },
  },
  data() {
    return {};
  },
};
</script>